export interface RatingInitializer {
  totalCount: number;
  average: number;
}

export default class Rating {
  public readonly totalCount: number;
  public readonly average: number;

  constructor(init: RatingInitializer) {
    this.totalCount = init.totalCount;
    this.average = init.average;
  }
}
